import { FieldDataEntity, FieldDataEntityApi } from './entity';

export const normalizeFieldData = (
  raw: FieldDataEntityApi
): FieldDataEntity => ({
  id: raw.id,
  name: raw.name,
  dataType: raw.data_type,
});
